<template>
  <div id="app">
    <Category :project-id="projectId" />
  </div>
</template>

<script>
import Category from "@/components/category/CategoryList"

export default {
  name: "App",
  components: {
    Category,
  },
  props: {
    projectId: {
      type: String,
      default: null
    }
  }
}
</script>
